import React, { useState } from 'react';
import './ViewTopics.css';
import TopicModal from './TopicModal';

interface Topic {
    IdTableTopic: number;
    Topic: string;
    Description: string;
    StartTime: string;
    EndTime: string;
    Availabilities: { StartTime: string; EndTime: string }[];
}

interface TopicsModalProps {
    topics: Topic[];
    onClose: () => void;
    IdEventTable: number;
}

const ViewTopics: React.FC<TopicsModalProps> = ({ topics, onClose, IdEventTable }) => {
    const [selectedTopic, setSelectedTopic] = useState<Topic | null>(null);
    const [isTopicModalOpen, setIsTopicModalOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState<string | null>(null);

    const handleTopicClick = (topic: Topic) => {
        setSelectedTopic(topic);
    };

    const handleAddTopic = () => {
        setIsTopicModalOpen(true);
    };

    const handleConfirm = (title: string, description: string, availabilities: { StartTime: string, EndTime: string }[]) => {
        setIsTopicModalOpen(false);
        // Simulate API call response
        const isSuccess = true; // Change this based on actual API response
        if (isSuccess) {
            setResponseMessage('Topic created successfully!');
        } else {
            setResponseMessage('Failed to create topic.');
        }
    };

    const onCancel = () => {
        setIsTopicModalOpen(false);
    };

    return (
        <div className="view-topics-modal">
            <div className="topics-modal-content">
                <button className="view-topic-close-button" onClick={onClose}>×</button>
                <h2>Available Topics</h2>
                {responseMessage && <div className="response-message">{responseMessage}</div>}
                {selectedTopic ? (
                    <div>
                        <h3>{selectedTopic.Topic}</h3>
                        <p>Description: {selectedTopic.Description}</p>
                        <p>Availabilities:</p>
                        <ul>
                            {selectedTopic.Availabilities.map((availability, index) => (
                                <li key={index}>
                                    Start Time: {availability.StartTime}, End Time: {availability.EndTime}
                                </li>
                            ))}
                        </ul>
                        <button onClick={() => setSelectedTopic(null)}>Back to Topics</button>
                    </div>
                ) : (
                    <div>
                        <ul>
                            {topics.map(topic => (
                                <li key={topic.IdTableTopic} onClick={() => handleTopicClick(topic)}>
                                    {topic.Topic}
                                </li>
                            ))}
                        </ul>
                        <div className="add-topic-button">
                            <button onClick={handleAddTopic}>Add Topic</button>
                        </div>
                    </div>
                )}
            </div>

            {isTopicModalOpen && (
                <TopicModal
                    IdEventTable={IdEventTable}
                    onConfirm={handleConfirm}
                    onCancel={onCancel} />
            )}
        </div>
    );
};

export default ViewTopics;